module.exports = __webpack_public_path__ + "img/5_68.2993181a.png";